// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { accountSummaryDashboardStyles } from "@steiner/App/Widgets/AccountSummary/AccountSummaryDashboard";
import { xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

accountSummaryDashboardStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 400px;
        gap: 20px 16px;
        align-items: flex-start;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
        }
    `,
};

accountSummaryDashboardStyles.infoContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto;
        gap: 8px 12px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr 1fr;
        }
    `,
};

accountSummaryDashboardStyles.labelText = {
    css: css`
        ${xScreen("lt", "sm")} {
            display: flex;
            flex-direction: column;
            gap: 4px;
        }
    `,
};
